import React from 'react';
import { AttestantQuery_node_TEDLRAttestant__Associations_Reserver_All } from '../../Queries/_QueryTypes/AttestantQuery';

export interface IReservContext {
  dialogOpen: boolean;
  setDialogOpen: (value: boolean) => void;
  attestrattID: string | null;
  setAttestrattID: (value: string | null) => void;
  editStandin?: AttestantQuery_node_TEDLRAttestant__Associations_Reserver_All;
  setEditStandin: (
    value:
      | AttestantQuery_node_TEDLRAttestant__Associations_Reserver_All
      | undefined
  ) => void;
}

export const ReservContext = React.createContext<IReservContext>({
  dialogOpen: false,
  setDialogOpen: () => {},
  attestrattID: null,
  setAttestrattID: () => {},
  setEditStandin: () => {},
});
